import React, { useEffect, useState } from 'react'
import LineChart from '../../DetailPage/LineChart'
import Carousel from 'react-bootstrap/Carousel';
import { getFeaturedMarekets } from '../../../utils/services';
import { LIGHT_THEME } from '../../../utils/constants';
import { formatNumbers, renderOptions, convertFromWeiEthers, getTokenSymbol, isStableTokenSymbol } from '../../../utils/helpers';
import { useTheme } from '../../../contexts/ThemeProvider';
import PoolTimerUI from '../../DetailPage/PoolTimerUI';
import useWeb3 from '../../../hooks/useWeb3';
import { MARKET_STATUS, MARKET_STATUS_BACKGROUNDS, MARKET_STATUS_TEXT_COLORS } from '../../../utils/MarketStatus';
import { useTranslation } from 'react-i18next';
import { detailPath } from '../../../constants/Routes';

const MarketCarousel = ({ tokenPrice }) => {
    const { theme } = useTheme()
    const web3 = useWeb3()
    const [index, setIndex] = useState(0);
    const [featuredMarekets, setFeaturedMarekets] = useState([]);
    const [pollStatus, setPollStatus] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);
    const { t } = useTranslation()

    const handleSelect = (selectedIndex) => setIndex(selectedIndex);

    useEffect(() => {
        ((async () => {
            try {
                const data = await getFeaturedMarekets();
                setFeaturedMarekets(data);
            } catch (error) {
                console.log("error in getting featured markets:", error);
            }
        }))()
    }, []);
    return (
        <>
            <div style={{ position: "relative" }}>
                <Carousel activeIndex={index} onSelect={handleSelect} controls={false}>
                    {featuredMarekets && featuredMarekets?.length > 0 ? (
                        featuredMarekets?.map((market, idindexx) => {
                            const volumeDecimal = convertFromWeiEthers(market?.totalVolume, market?.token?.tokenDecimals);
                            const dataByPair = market?.priceData.reduce((acc, item) => {
                                const pairIndex = parseInt(item.pair) - 1;
                                if (!acc[pairIndex]) {
                                    acc[pairIndex] = { percentages: [], timestamps: [] };
                                }
                                acc[pairIndex].percentages.push(item.percentage);
                                acc[pairIndex].timestamps.push(item.createdAt);
                                return acc;
                            }, []);
                            return (
                                <Carousel.Item key={market._id}>
                                    <a href={detailPath(market._id)}>
                                        <div className="parent-box">
                                            <div className="left-side">
                                                <div className="pool-info">
                                                    <div className="upper-field">
                                                        <p>
                                                            {!isStableTokenSymbol(market?.token?.tokenSymbol) && <span className='incentiv-bg'><span className="incetiv-tag">Alt-coins</span></span>} {" "}
                                                            {market?.tags?.length > 0 ? (
                                                                <>
                                                                    {market.tags.slice(0, 2).join(", ")}
                                                                    {market.tags.length > 2 && ` +${market.tags.length - 2} More`}
                                                                </>
                                                            ) : (
                                                                t("")

                                                            )}
                                                        </p>
                                                        <span className='live-box' style={{ backgroundColor: MARKET_STATUS_BACKGROUNDS[market.status], color: MARKET_STATUS_TEXT_COLORS[market.status] }}>{t(MARKET_STATUS[market?.status])}</span>
                                                    </div >
                                                    <h4 className='title-text'>{market?.question}</h4>
                                                    <div className="mid-fields">
                                                        {renderOptions(
                                                            market.options,
                                                            2,
                                                            false,
                                                            theme
                                                        )}
                                                    </div>

                                                    <div className="bottom-field">
                                                        <div className="single-text">
                                                            <p>{t("Volume")}</p>
                                                            <h6>${+volumeDecimal && +tokenPrice ?
                                                                formatNumbers(
                                                                    isStableTokenSymbol(market?.token?.tokenSymbol)
                                                                        ? +volumeDecimal
                                                                        : +volumeDecimal * +tokenPrice
                                                                )
                                                                : "0"
                                                            }</h6>
                                                        </div>
                                                        <div className="single-text">
                                                            <h6>   <PoolTimerUI
                                                                poolstart={market?.startDate}
                                                                poolend={market?.endDate}
                                                                poolsdetail={market}
                                                                setPollStatus={setPollStatus}
                                                                setIsDisabled={setIsDisabled}
                                                                endedTextColor={theme === LIGHT_THEME ? "#212121" : "#FFFFFF"}
                                                            /></h6>
                                                        </div>
                                                    </div>
                                                </div >
                                            </div >
                                            <span className='border-line'></span>
                                            {
                                                window.innerWidth > 991 && (
                                                    <div className="right-side">
                                                        <LineChart
                                                            options={market?.options}
                                                            data={dataByPair}
                                                        />
                                                    </div>
                                                )
                                            }
                                        </div ></a >
                                </Carousel.Item >

                            )
                        })

                    ) : (<div style={{ position: "relative" }} className="skeleton-view">
                        <div className="parent-box">
                            <div className="left-side">
                                <div className="pool-info">
                                    <div className="upper-field">
                                        <div
                                            className="shimmer-box small"
                                            style={{ width: "100px", height: "30px" }}
                                        ></div>
                                        <div
                                            className="shimmer-box small"
                                            style={{
                                                width: "50px",
                                                height: "30px",
                                                borderRadius: "6px",
                                            }}
                                        ></div>
                                    </div>

                                    <div
                                        className="shimmer-box text"
                                        style={{ width: "80%", height: "45px", margin: "12px 0" }}
                                    ></div>

                                    <div className="mid-fields">
                                        <div
                                            className="shimmer-box small"
                                            style={{ width: "45%", height: "30px", marginBottom: "8px" }}
                                        ></div>
                                        <div
                                            className="shimmer-box small"
                                            style={{ width: "45%", height: "30px" }}
                                        ></div>
                                    </div>

                                    <div className="bottom-field">
                                        <div className="single-text">
                                            <div
                                                className="shimmer-box small"
                                                style={{ width: "80px", height: "45px", marginBottom: "6px" }}
                                            ></div>
                                            <div
                                                className="shimmer-box text"
                                                style={{ width: "100px", height: "16px" }}
                                            ></div>
                                        </div>
                                        <div className="single-text">
                                            <div
                                                className="shimmer-box small"
                                                style={{ width: "100px", height: "30px" }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span className="border-line"></span>
                            {window.innerWidth > 991 && (
                                <div className="right-side">
                                    <div
                                        className="shimmer-box"
                                        style={{ width: "100%", height: "340px", borderRadius: "8px" }}
                                    ></div>

                                    <div className="option-parent mt-3">
                                        {Array.from({ length: 3 }).map((_, j) => (
                                            <div
                                                key={j}
                                                className="option-list"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                <div
                                                    className="shimmer-circle"
                                                    style={{ width: "12px", height: "12px" }}
                                                ></div>
                                                <div
                                                    className="shimmer-box small"
                                                    style={{ width: "60px", height: "12px" }}
                                                ></div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    )
                    }


                </Carousel >
                <div className="twice-btns">
                    <a onClick={() => setIndex((index - 1 + 5) % 5)}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path d="M2.00675 7.81101L6.21425 12.0185C6.30197 12.1062 6.42095 12.1555 6.545 12.1555C6.66906 12.1555 6.78804 12.1062 6.87576 12.0185C6.96348 11.9308 7.01277 11.8118 7.01277 11.6878C7.01277 11.5637 6.96348 11.4447 6.87576 11.357L3.46593 7.94775L12.6225 7.94775C12.7465 7.94775 12.8654 7.8985 12.9531 7.81083C13.0408 7.72315 13.09 7.60424 13.09 7.48025C13.09 7.35626 13.0408 7.23735 12.9531 7.14968C12.8654 7.06201 12.7465 7.01275 12.6225 7.01275L3.46593 7.01275L6.87576 3.60351C6.96348 3.51579 7.01277 3.39681 7.01277 3.27275C7.01277 3.14869 6.96348 3.02972 6.87576 2.942C6.78804 2.85427 6.66906 2.80499 6.545 2.80499C6.42095 2.80499 6.30197 2.85427 6.21425 2.942L2.00675 7.1495C1.96328 7.19291 1.9288 7.24447 1.90527 7.30123C1.88175 7.35798 1.86964 7.41882 1.86964 7.48025C1.86964 7.54169 1.88175 7.60252 1.90527 7.65928C1.9288 7.71603 1.96328 7.76759 2.00675 7.81101Z" fill="#AFAFAF" />
                    </svg></a>
                    <a onClick={() => setIndex((index + 1) % 5)}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path d="M12.9533 7.81101L8.74575 12.0185C8.65803 12.1062 8.53905 12.1555 8.415 12.1555C8.29094 12.1555 8.17196 12.1062 8.08424 12.0185C7.99652 11.9308 7.94723 11.8118 7.94723 11.6878C7.94723 11.5637 7.99652 11.4447 8.08424 11.357L11.4941 7.94775L2.3375 7.94775C2.21351 7.94775 2.0946 7.8985 2.00692 7.81083C1.91925 7.72315 1.87 7.60424 1.87 7.48025C1.87 7.35626 1.91925 7.23735 2.00692 7.14968C2.0946 7.06201 2.21351 7.01275 2.3375 7.01275L11.4941 7.01275L8.08424 3.60351C7.99652 3.51579 7.94723 3.39681 7.94723 3.27275C7.94723 3.14869 7.99652 3.02972 8.08424 2.942C8.17196 2.85427 8.29094 2.80499 8.415 2.80499C8.53905 2.80499 8.65803 2.85427 8.74575 2.942L12.9533 7.1495C12.9967 7.19291 13.0312 7.24447 13.0547 7.30123C13.0783 7.35798 13.0904 7.41882 13.0904 7.48025C13.0904 7.54169 13.0783 7.60252 13.0547 7.65928C13.0312 7.71603 12.9967 7.76759 12.9533 7.81101Z" fill="#212121" />
                    </svg></a>
                </div>
            </div >


        </>
    )
}

export default MarketCarousel
